import type { Metric } from 'web-vitals';

/**
 * Reports Web Vitals metrics for performance monitoring
 * Metrics: LCP, FID, CLS, FCP, TTFB
 *
 * In development, logs to console
 * In production, can be configured to send to analytics endpoint
 */
export function reportWebVitals(onPerfEntry?: (metric: Metric) => void): void {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  } else {
    // Default: log to console in development
    import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB }) => {
      const logMetric = (metric: Metric) => {
        if (import.meta.env.DEV) {
          console.log(`[Web Vitals] ${metric.name}:`, {
            value: metric.value.toFixed(2),
            rating: metric.rating, // 'good', 'needs-improvement', or 'poor'
            delta: metric.delta.toFixed(2),
          });
        }
      };
      onCLS(logMetric);
      onFCP(logMetric);
      onLCP(logMetric);
      onTTFB(logMetric);
    });
  }
}
